"use client";

import { useLanguageStore } from "@/providers/useLanguageStore";
import Image from "next/image";
import React from "react";
import { FaWhatsapp, FaInstagram, FaEnvelope } from "react-icons/fa";
import { PHONE_NUMBER } from "@/constants/contact";

const ContactInfo: React.FC = () => {
  const { translations } = useLanguageStore();

  return (
    <div className="bg-red-600 text-white p-8 relative">
      <div className="mx-4 md:mx-4 lg:mx-16">
        <h3 className="text-4xl font-bold mb-6">{translations.helpTitle}</h3>
        <ul className="space-y-4">
          <li className="flex items-center">
            <FaWhatsapp className="text-white text-2xl" />
            <span className="ml-2">{PHONE_NUMBER}</span>
          </li>
          <li className="flex items-center">
            <FaInstagram className="text-white text-2xl" />
            <span className="ml-2">rollingcodeschool</span>
          </li>
          <li className="flex items-center">
            <FaEnvelope className="text-white text-2xl" />
            <span className="ml-2">customers@rollingcodestudio.com</span>
          </li>
        </ul>
      </div>

      <div className="hidden md:absolute bottom-0 left-0 w-full h-full md:grid  grid-cols-12 grid-rows-12">
        <div className="col-start-1 col-end-3 row-start-11 row-end-13 bg-black"></div>
        <div className="col-start-5 col-end-7 row-start-11 row-end-12 bg-black"></div>

        <div className="col-start-7 col-end-8 row-start-12 row-end-13 bg-white"></div>
        <div className="col-start-7 col-end-10 row-start-10 row-end-11 bg-white"></div>
        <Image
          src="/images/cohete.webp"
          alt="Cohete"
          className=" md:absolute left-20 bottom-0 translate-y-10 transform rotate-[0deg]"
          width={150}
          height={150}
          priority
        />
      </div>
      <div className="absolute md:hidden bottom-0 left-0 w-full h-full grid  grid-cols-12 grid-rows-12">
        <Image
          src="/images/cohete.webp"
          alt="Cohete"
          className="md:hidden absolute right-2 top-20 translate-y-10 transform rotate-[0deg]"
          width={80}
          height={80}
          priority
        />
      </div>
    </div>
  );
};

export default ContactInfo;
